import { Intent, Position, Toaster } from '@blueprintjs/core'

export const toastSuccess = (message: string) =>
  Toaster.create({ className: 'recipe-toaster', position: Position.TOP_RIGHT }).show({
    message,
    intent: Intent.SUCCESS,
    timeout: 1000
  })

export const toastFailure = (message: string) =>
  Toaster.create({ className: 'recipe-toaster', position: Position.TOP_RIGHT }).show({
    message,
    intent: Intent.DANGER,
    timeout: 3000
  })

export const toastInfo = (message: string) =>
  Toaster.create({ className: 'recipe-toaster', position: Position.TOP_RIGHT }).show({
    message,
    intent: Intent.PRIMARY,
    timeout: 1000
  })
